define([
    'uiComponent',
    'mage/translate',
    'Lfi_Customer/js/model/state'
], (Component, __, customerState) => {
    'use strict';

    return Component.extend({
        isCustomerLoggedIn: () => customerState.isLoggedIn(),
        getText: function () {
            if (customerState.isLoggedIn()) {
                return __('Hi, %1').replace('%1', customerState.getPersistentCustomerFirstname());
            }

            return __('Sign In');
        }
    });
});
